exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".delete-project-modal{width:400px !important}.delete-project-modal .account-btn{margin-top:16px}", ""]);

